import { render, staticRenderFns } from "./SliderSvg.vue?vue&type=template&id=0edeb8e8"
import script from "./SliderSvg.vue?vue&type=script&lang=js"
export * from "./SliderSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0edeb8e8')) {
      api.createRecord('0edeb8e8', component.options)
    } else {
      api.reload('0edeb8e8', component.options)
    }
    module.hot.accept("./SliderSvg.vue?vue&type=template&id=0edeb8e8", function () {
      api.rerender('0edeb8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Visualisations/SliderSvg.vue"
export default component.exports